export const authConfig = {
  enableOtpPasswordReset: false,
  passwordResetContact: {
    name: 'Super Admin',
    telegram: '@MEASPUTTIVIREAK',
    telegramUrl: 'https://t.me/MEASPUTTIVIREAK',
  },
}
